const initialState = {
    simpleStore : false 
};

const storeReducer = (state = initialState, action) => {
    switch(action.type){
        case 'TOGGLE_SIMPLE_STORE' : {
            return {
                simpleStore : !state.simpleStore
            };
        } break;
    }

    return state;
}

export default storeReducer;


// WEBPACK FOOTER //
// ./src/reducers/storeReducer.js